import {Button, Container, Row, Spinner} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong, faPlus} from "@fortawesome/free-solid-svg-icons";
import MusicFilesManager from "./MusicFilesManager";
import AddPlaylist from "./modals/addPlaylist";
import PlaylistsService, {remove, updateActive, updateFiles} from "../services/playlistsService";
import PlaylistView from "./common/PlaylistView";
import Col from "react-bootstrap/Col";
import FileView from "./common/FileView";
import MusicFilesService from "../services/musicFilesService";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import ConfirmationModalContextProvider from "./common/modalConfirmationContext";


function ReportsSending() {
    const [showFileManager, setShowFileManager] = useState(false);
    const [showAddPlaylistModal, setShowAddPlaylistModal] = useState(false);

    const [playlists, setPlaylists] = useState([]);
    const [playlistToEdit, setPlaylistToEdit] = useState(null);
    const [playlistToView, setPlaylistToView] = useState(null);
    const [allFiles, setAllFiles] = useState([]);
    const [changes, setChanges] = useState(false);

    const uploadFiles = async () => {
        try {
            let result = await MusicFilesService.getAll();
            setAllFiles(result.data);
        } catch (e) {

        }
    }

    const uploadPlaylists = async () => {
        try {
            let result = await PlaylistsService.getAll();
            setPlaylists(result.data);
        } catch (e) {

        }
    }

    const handlePlaylistRefresh = async () => {
        uploadPlaylists();
    }

    const handlePlaylistClick = (event, playlist) => {
        event.stopPropagation();
        setPlaylistToView(playlist);
        setChanges(false);
    }

    const handelPlaylistEdit = (event, _id) => {
        event.stopPropagation();
        if (_id !== null) {
            const result = playlists.find((playlist) => playlist._id === _id);
            if (result) {
                setPlaylistToEdit(result);
            }
        } else {
            setPlaylistToEdit(null);
        }

        setShowAddPlaylistModal(true);
    }

    const handleSetActivePlaylist = async (e, _id) => {
        e.stopPropagation();
        try {
            let result = await PlaylistsService.updateActive(_id);
            if (result.status === 200) {
                uploadPlaylists();
            }
        } catch (e) {
            toast.error("Błąd ustawiania playlisty jako obowiązującej");
        }
    }

    const handleDeletePlaylist = async (e, _id) => {
        try {
            let result = await PlaylistsService.remove(_id);
            if (result.status === 200) {
                uploadPlaylists();
            }
        } catch (e) {
            toast.error("Błąd usuwania playlisty");
        }
    }

    const handleAddToPlaylist = (_id) => {
        let playlist = {...playlistToView};
        if (playlist.files.findIndex((file) => file === _id) === -1) {
            playlist.files.push(_id);
            setPlaylistToView(playlist);
            setChanges(true);
        }

    }

    const handleRemoveFromPlaylist = (_id) => {
        let playlist = {...playlistToView};
        playlist.files = playlist.files.filter((file) => file !== _id);
        setPlaylistToView(playlist);

    }

    const saveFilesToPlaylist = async () => {
        try {
            let result = await PlaylistsService.updateFiles(playlistToView._id, playlistToView.files);
            if (result.status === 200) {
                toast.success("Zapisano playlistę");
                setChanges(false);
            }
        } catch (e) {
            toast.error("Błąd zapisu playlisty");
        }
    }

    useEffect(() => {
        try {
            uploadPlaylists();
            uploadFiles();
        } catch (e) {
            console.log(e);
        }


    }, []);

    const handleCloseFileManager = () => {
        setShowFileManager(false);
    }

    const returnToListOfPlaylist = async () => {
        setPlaylistToView(null);
        await uploadPlaylists();
        await uploadFiles();
    }

    return (
        <React.Fragment>
            <Breadcrumb style={{backgroundColor: "#DDDDDD"}}>
                <Breadcrumb.Item style={{marginTop: 3, marginLeft: 3, marginBottom: 3, marginRight: 0}} href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item style={{marginTop: 3, marginLeft: 3, marginBottom: 3, marginRight: 0}}>Zarządzanie muzyką</Breadcrumb.Item>
                <Breadcrumb.Item style={{marginTop: 3, marginLeft: 3, marginBottom: 3, marginRight: 0}} active>Playlisty</Breadcrumb.Item>
            </Breadcrumb>
            <div className="App">
                <div>
                    <ToastContainer/>
                </div>
                <Container fluid>
                    

                </Container>
            </div>
        </React.Fragment>

    )
        ;
}

export default ReportsSending;
